var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureIotHub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_131)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.327 134.58C150.787 134.58 156.023 129.281 156.023 122.746C156.023 116.21 150.787 110.911 144.327 110.911C137.868 110.911 132.632 116.21 132.632 122.746C132.632 129.281 137.868 134.58 144.327 134.58Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.626 166.533C168.793 166.533 172.982 162.294 172.982 157.065C172.982 151.836 168.793 147.598 163.626 147.598C158.458 147.598 154.269 151.836 154.269 157.065C154.269 162.294 158.458 166.533 163.626 166.533Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.368 158.84C131.567 158.84 134.971 155.396 134.971 151.148C134.971 146.9 131.567 143.456 127.368 143.456C123.17 143.456 119.766 146.9 119.766 151.148C119.766 155.396 123.17 158.84 127.368 158.84Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.105 100.26C127.273 100.26 131.462 96.0216 131.462 90.7929C131.462 85.5642 127.273 81.3254 122.105 81.3254C116.938 81.3254 112.748 85.5642 112.748 90.7929C112.748 96.0216 116.938 100.26 122.105 100.26Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7895 134.58C99.9881 134.58 103.392 131.136 103.392 126.888C103.392 122.639 99.9881 119.195 95.7895 119.195C91.5908 119.195 88.1871 122.639 88.1871 126.888C88.1871 131.136 91.5908 134.58 95.7895 134.58Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.38 155.29L146.082 120.97L144.327 122.154L145.497 120.97L123.86 89.0177L119.766 91.9763L139.064 120.379L95.7895 123.929L96.3743 128.663L139.064 125.112L125.029 149.373L129.123 151.74L143.743 126.888L161.287 157.657L165.38 155.29Z",
    fill: "#949494"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180 80.142C180 77.7751 178.246 76 175.906 76H153.684C152.515 76 151.345 77.1834 151.345 78.3669V86.6509C151.345 87.8343 152.515 89.0177 153.684 89.0177H167.719V102.627C167.719 103.811 168.889 104.994 170.058 104.994H177.661C178.83 104.994 180 103.811 180 102.627V80.142Z",
    fill: "#949494"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.901 163.574H92.8655V149.965C92.8655 148.781 91.6959 147.598 90.5263 147.598H82.3392C81.1696 147.598 80 148.781 80 149.965V171.858C80 174.225 81.7544 176 84.0936 176H106.316C107.485 176 108.655 174.817 108.655 173.633V165.349C108.655 164.757 108.07 163.574 106.901 163.574Z",
    fill: "#949494"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.327 110.911C150.76 110.911 156.023 116.237 156.023 122.746C156.023 129.254 150.76 134.58 144.327 134.58C137.895 134.58 132.632 129.254 132.632 122.746C132.632 116.237 137.895 110.911 144.327 110.911ZM112.749 90.7929C112.749 96.1184 116.842 100.852 122.69 100.852C127.953 100.852 132.632 96.7101 132.632 90.7929C132.632 84.8757 128.538 80.7337 122.69 80.7337C116.842 81.3255 112.749 85.4675 112.749 90.7929ZM88.1871 126.888C88.1871 131.03 91.6959 134.58 95.7895 134.58C99.883 134.58 103.392 131.03 103.392 126.888C103.392 122.746 99.883 119.195 95.7895 119.195C91.6959 119.195 88.1871 122.746 88.1871 126.888ZM119.766 151.148C119.766 155.29 123.275 158.84 127.368 158.84C131.462 158.84 134.971 155.29 134.971 151.148C134.971 147.006 131.462 143.456 127.368 143.456C123.275 142.864 119.766 146.414 119.766 151.148ZM154.269 157.065C154.269 162.391 158.363 166.533 163.041 166.533C168.304 166.533 172.398 162.391 172.398 157.657C172.398 152.331 168.304 148.189 163.626 148.189C158.363 148.189 154.269 152.331 154.269 157.065Z",
    fill: "url(#paint0_linear_2_131)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_131",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_131"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_131",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_131",
    x1: 130.792,
    y1: 183.905,
    x2: 129.115,
    y2: 24.6744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#22A5CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#29BADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2EC9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#31D1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#32D4F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureIotHub);
export default __webpack_public_path__ + "static/media/azure-iot-hub.b7c6c9f82641eced4e6afc3689fb32fc.svg";
export { ForwardRef as ReactComponent };